import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const IMPERSONATION_TOKEN_KEY = "addbills.access_token";
const IMPERSONATION_FLAG_KEY = "addbills.impersonating";
const IMPERSONATION_EMAIL_KEY = "addbills.impersonating_email";

export function setImpersonationData(token: string, email: string): void {
  sessionStorage.setItem(IMPERSONATION_FLAG_KEY, "true");
  sessionStorage.setItem(IMPERSONATION_EMAIL_KEY, email);
  localStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
}

export function getImpersonation(): { active: boolean; email: string } {
  const flag = sessionStorage.getItem(IMPERSONATION_FLAG_KEY) === "true";
  const email = sessionStorage.getItem(IMPERSONATION_EMAIL_KEY) ?? "";
  return { active: flag, email };
}

export function clearImpersonation(): void {
  sessionStorage.removeItem(IMPERSONATION_FLAG_KEY);
  sessionStorage.removeItem(IMPERSONATION_EMAIL_KEY);
  localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
}

export default function Impersonate() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const pending = localStorage.getItem("addbills.pending_impersonation");
    if (!pending) {
      navigate("/login", { replace: true });
      return;
    }

    localStorage.removeItem("addbills.pending_impersonation");

    try {
      const { token, email } = JSON.parse(pending);
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }
      setImpersonationData(token, email ?? "");
      navigate("/dashboard", { replace: true });
    } catch {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="flex items-center justify-center py-20 text-sm text-slate-500">
      Redirecting...
    </div>
  );
}
